import axios from "@axios";
import { hasError } from "@/utils/utils";
import { downloadFile } from "../utils/utils";
import dayjs from "dayjs";
import { BACK_BASE_URL } from "@/base-url";
import { jsonToGraphQLQuery } from "json-to-graphql-query";
import unset from "lodash.unset";
import * as XLSX from 'xlsx';  
import { saveAs } from 'file-saver';
function toTitleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
export default {
  namespaced: true,
  state: {
    exporting: false,
    gqlQueryToExport: null,
  },
  mutations: {
    setExporting(state, payload) {
      state.exporting = payload;
    },
    setGqlQueryToExport(state, payload) {
      state.gqlQueryToExport = payload;
    },
  },
  getters: {
    exporting(state) {
      return state.exporting;
    },
    gqlQueryToExport(state) {
      return state.gqlQueryToExport;
    },
  },
  actions: {
    async exportToExcel({ commit }, ep) {
      this._vm.$toast("جارٍ تصدير الجدول ...", {
        id: "export-toast",
        timeout: false,
        closeButton: false,
        draggable: false,
        type: "info",
        position: "bottom-center",
      });
      commit("setExporting", true);

      try {
        const res = await axios.get(ep, {
          headers: {
            "To-Excel": true,
          },
          responseType: "blob",
        });

        if (hasError(res.status)) throw res.status;
        const fileName = `Report - ${dayjs().format("YYYY-MM-DD HH-mm")}.xlsx`;
        downloadFile(res.data, fileName);
        this._vm.$toast.update("export-toast", {
          content: "تم تصدير الجدول بنجاح.",
          options: {
            id: "export-toast",
            draggable: true,
            type: "success",
            timeout: 5000,
          },
        });
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast.update("export-toast", {
          content: "حدث خطأ أثناء تصدير الجدول !",
          options: {
            id: "export-toast",
            draggable: true,
            type: "error",
            timeout: 5000,
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setExporting", false);
      }
    },
    async exportGqlToExcel({ commit, state }) {
      this._vm.$toast("جارٍ تصدير الجدول ...", {
        id: "export-toast",
        timeout: false,
        closeButton: false,
        draggable: false,
        type: "info",
        position: "bottom-center",
      });
      commit("setExporting", true);
      const query = { ...state.gqlQueryToExport };
      const tableName = Object.keys(query)[0];
      const nametoPascalCase = tableName.charAt(0).toUpperCase() + tableName.slice(1);
      query[`all${nametoPascalCase}`] = query[tableName].data;
      query[`all${nametoPascalCase}`].__args = query[tableName].__args;
      unset(query, tableName);

      unset(query[`all${nametoPascalCase}`], "__args.first");
      unset(query[`all${nametoPascalCase}`], "__args.page");
      try {
        const res = await axios.post(
          `${BACK_BASE_URL}/v2/ministry/graphql`,
          {
            operation: null,
            query: `{${jsonToGraphQLQuery(query, { pretty: true })}}`,
            variables: {},
          },
          // {
          //   headers: {
          //     "To-Excel": true,
          //   },
          //   responseType: "blob",
          // }
        );
        console.log("res" , res.data[Object.keys(res)[0]])
        if (hasError(res.status)) throw res.status;
        const fileName = `Report - ${dayjs().format("YYYY-MM-DD HH-mm")}.xlsx`;

        // downloadFile(res.data, fileName);
        // this._vm.$toast.update("export-toast", {
        //   content: "تم تصدير الجدول بنجاح.",
        //   options: {
        //     id: "export-toast",
        //     draggable: true,
        //     type: "success",
        //     timeout: 5000,
        //   },
        // });
        // const wb = XLSX.utils.book_new();  
        // const ws = XLSX.utils.table_to_sheet(res.status);  
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');  
        // XLSX.writeFile(wb, fileName);  
         // Create a new workbook
         const wb = XLSX.utils.book_new();
         // Convert your data to a worksheet
         console.log("Object.keys(res.data" , Object.keys(res.data.data))
         let data = res.data.data[Object.keys(res.data.data)[0]]
         
         data.forEach((el) => {
            console.log(el)
          });
         console.log("this.status[Object.keys(res)[0]]" , data)
         const ws = XLSX.utils.json_to_sheet(data);
         // Append worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Data');

         // Generate an Excel file and trigger download
         const excelBuffer = XLSX.write(wb, {
           bookType: 'xlsx',
           type: 'array'
         });
         const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
         saveAs(file, 'MyData.xlsx');

        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast.update("export-toast", {
          content: "حدث خطأ أثناء تصدير الجدول !",
          options: {
            id: "export-toast",
            draggable: true,
            type: "error",
            timeout: 5000,
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setExporting", false);
      }
    },
    async customExport(
      { commit },
      { ep, params, headers } = {
        ep: "",
        params: {},
        headers: { "To-Excel": true },
      }
    ) {
      this._vm.$toast("جارٍ تصدير الجدول ...", {
        id: "export-toast",
        timeout: false,
        closeButton: false,
        draggable: false,
        type: "info",
        position: "bottom-center",
      });
      commit("setExporting", true);

      try {
        const res = await axios.get(ep, {
          params,
          headers,
          responseType: "blob",
        });

        if (hasError(res.status)) throw res.status;
        const fileName = `Report - ${dayjs().format("YYYY-MM-DD HH-mm")}.xlsx`;
        downloadFile(res.data, fileName);
        this._vm.$toast.update("export-toast", {
          content: "تم تصدير الجدول بنجاح.",
          options: {
            id: "export-toast",
            draggable: true,
            type: "success",
            timeout: 5000,
          },
        });
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast.update("export-toast", {
          content: "حدث خطأ أثناء تصدير الجدول !",
          options: {
            id: "export-toast",
            draggable: true,
            type: "error",
            timeout: 5000,
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setExporting", false);
      }
    },
    async exportToExcelwithParam({ commit }, data) {
      console.log("params" , data)
      this._vm.$toast("جارٍ تصدير الجدول ...", {
        id: "export-toast",
        timeout: false,
        closeButton: false,
        draggable: false,
        type: "info",
        position: "bottom-center",
      });
      commit("setExporting", true);
      let headers = {}
      if(data.ep.includes('export-ngo-weights')){
        headers = {"Export": true};
        
      }else{
        headers = {"To-Excel": true};
      }
      try {
        const res = await axios.get(data.ep, {
          params : data.params ,
          headers: headers ,
          responseType: "blob",
        });

        if (hasError(res.status)) throw res.status;
        const fileName = `Report - ${dayjs().format("YYYY-MM-DD HH-mm")}.${data.ep.includes('export-ngo-weights') ? 'csv' :'xlsx'}`;
        downloadFile(res.data, fileName);
        this._vm.$toast.update("export-toast", {
          content: "تم تصدير الجدول بنجاح.",
          options: {
            id: "export-toast",
            draggable: true,
            type: "success",
            timeout: 5000,
          },
        });
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast.update("export-toast", {
          content: "حدث خطأ أثناء تصدير الجدول !",
          options: {
            id: "export-toast",
            draggable: true,
            type: "error",
            timeout: 5000,
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setExporting", false);
      }
    },
  },
};
